import React, {useEffect} from 'react';

import {useStore} from 'effector-react';
import {useTranslation} from 'react-i18next';

import {useHistory} from 'react-router-dom';

import {
    $invoiceIsRemoved,
    $invoiceState,
    $newInvoiceIsDone,
    deleteInvoiceFx,
} from 'models/documents/invoices/common';
import {$doesInvoiceExist} from 'models/documents/invoices/common/init';
import {
    arrStores,
    $invoiceCreationPage,
    invoiceCreationPage,
    $invoiceCreatingPending,
    setShowGroupLinesByGtinModal,
} from 'models/documents/invoices/create';

import {setXmlFile} from '../helpers/buildXml';

import {FlexContainer, ButtonsContainer, Button} from './styled';

export const ControlSection = ({
    onSubmit,
    nextIndex,
    nextIsDisabled = false,
}: {
    onSubmit: any;
    nextIndex?: number;
    nextIsDisabled?: boolean;
}) => {
    const {t} = useTranslation();
    // const invoiceIsRemoved = useStore($invoiceIsRemoved);
    // const newInvoiceIsDone = useStore($newInvoiceIsDone);
    // const history = useHistory();
    const invoiceCreatingPending = useStore($invoiceCreatingPending);
    const doesInvoiceExist = useStore($doesInvoiceExist);
    const currentPageIndex = useStore($invoiceCreationPage);
    const GEN_INFO = 'pages.documents.invoices.create';
    const STEPS_LENGTH = 4;
    const invoiceState = useStore($invoiceState);

    const generalDataFromStore = useStore(arrStores);

    // useEffect(() => {
    //     console.log(newInvoiceIsDone);
    //     if (newInvoiceIsDone || invoiceIsRemoved) {
    //         history.goBack();
    //     }
    // }, [newInvoiceIsDone, invoiceIsRemoved]);

    function turnPageNext() {
        if (nextIndex) {
            onSubmit(nextIndex);
        } else {
            onSubmit();
        }
    }
    function turnPagePrev() {
        invoiceCreationPage(currentPageIndex - 1);
    }

    function showXml() {
        setXmlFile(generalDataFromStore);
    }

    function sendForCreatingInvoice() {
        onSubmit();
        setShowGroupLinesByGtinModal(true);
    }

    function deleteInvoice() {
        if (invoiceState && invoiceState !== 'new') {
            deleteInvoiceFx(invoiceState);
        }
    }

    return (
        <ButtonsContainer>
            {doesInvoiceExist ? (
                <div>
                    <Button typeView="delete" type="button" onClick={deleteInvoice}>
                        {t(`${GEN_INFO}.buttons.delete`)}
                    </Button>
                </div>
            ) : (
                <div />
            )}
            <FlexContainer>
                {currentPageIndex ? (
                    <Button typeView="back" type="button" onClick={turnPagePrev}>
                        {t(`${GEN_INFO}.buttons.back`)}
                    </Button>
                ) : (
                    <></>
                )}
                {currentPageIndex >= STEPS_LENGTH - 1 ? (
                    !doesInvoiceExist ? (
                        <Button
                            disabled={invoiceCreatingPending}
                            onClick={sendForCreatingInvoice}
                            typeView="next"
                            type="button"
                        >
                            {t(`${GEN_INFO}.buttons.approve`)}
                        </Button>
                    ) : (
                        <></>
                    )
                ) : (
                    <Button
                        disabled={nextIsDisabled}
                        typeView="next"
                        type="button"
                        onClick={turnPageNext}
                    >
                        {t(`${GEN_INFO}.buttons.next`)}
                    </Button>
                )}
            </FlexContainer>
        </ButtonsContainer>
    );
};
